import axios from 'axios';

const API_URL = process.env.REACT_APP_API_BASE_URL;

export const fetchAllMenuItems = async (params = {}) => {
    try {
        const queryParams = new URLSearchParams();

        if (params.page) queryParams.append('page', params.page);
        if (params.limit) queryParams.append('limit', params.limit);
        if (params.category) queryParams.append('category', params.category);
        if (params.subCategory) queryParams.append('subCategory', params.subCategory);
        if (params.search) queryParams.append('search', params.search);
        if (params.sortBy) queryParams.append('sortBy', params.sortBy);
        if (params.sortOrder) queryParams.append('sortOrder', params.sortOrder);
        if (params.availability !== undefined) queryParams.append('availability', params.availability);
        if (params.status) queryParams.append('status', params.status);
        if (params.isPopular !== undefined) queryParams.append('isPopular', params.isPopular);
        if (params.isVegetarian !== undefined) queryParams.append('isVegetarian', params.isVegetarian);
        if (params.isVegan !== undefined) queryParams.append('isVegan', params.isVegan);
        if (params.isGlutenFree !== undefined) queryParams.append('isGlutenFree', params.isGlutenFree);
        if (params.spiceLevel) queryParams.append('spiceLevel', params.spiceLevel);
        if (params.minPrice) queryParams.append('minPrice', params.minPrice);
        if (params.maxPrice) queryParams.append('maxPrice', params.maxPrice);

        const query = queryParams.toString();
        const response = await axios.get(`${API_URL}/api/menu${query ? `?${query}` : ''}`);
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

export const fetchAvailableMenuItems = async (params = {}) => {
    try {
        const queryParams = new URLSearchParams();

        if (params.page) queryParams.append('page', params.page);
        if (params.limit) queryParams.append('limit', params.limit);
        if (params.category) queryParams.append('category', params.category);
        if (params.subCategory) queryParams.append('subCategory', params.subCategory);
        if (params.search) queryParams.append('search', params.search);
        if (params.sortBy) queryParams.append('sortBy', params.sortBy);
        if (params.sortOrder) queryParams.append('sortOrder', params.sortOrder);
        if (params.isPopular !== undefined) queryParams.append('isPopular', params.isPopular);
        if (params.isVegetarian !== undefined) queryParams.append('isVegetarian', params.isVegetarian);
        if (params.isVegan !== undefined) queryParams.append('isVegan', params.isVegan);
        if (params.isGlutenFree !== undefined) queryParams.append('isGlutenFree', params.isGlutenFree);
        if (params.spiceLevel) queryParams.append('spiceLevel', params.spiceLevel);
        if (params.minPrice) queryParams.append('minPrice', params.minPrice);
        if (params.maxPrice) queryParams.append('maxPrice', params.maxPrice);

        const query = queryParams.toString();
        const response = await axios.get(`${API_URL}/api/menu/available${query ? `?${query}` : ''}`);
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

export const fetchMenuItemsByCategory = async (category) => {
    try {
        const response = await axios.get(`${API_URL}/api/menu/category/${category}`);
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

export const fetchMenuCategories = async () => {
    try {
        const response = await axios.get(`${API_URL}/api/menu/categories`);
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

export const fetchMenuItemById = async (id) => {
    try {
        const response = await axios.get(`${API_URL}/api/menu/${id}`);
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};

export const fetchMenuItemAvailability = async (id) => {
    try {
        const response = await axios.get(`${API_URL}/api/menu/${id}/availability`);
        return response.data;
    } catch (error) {
        throw error.response?.data || error;
    }
};
